import {RecommendationMessagesElement} from "./RecommendationMessagesElement";

const COLOR = "#D97706";

export function RecommendationsWarningElement({
    messages,
    locale,
    printMode = false
}: {
    messages: Record<string, string>[] | undefined;
    locale: string;
    printMode?: boolean;
}) {
    return (
        <RecommendationMessagesElement
            messages={messages}
            locale={locale}
            color={COLOR}
            borderOpacity={0.28}
            printMode={printMode}
        />
    );
}
